import React, { useState } from 'react';
import { Trans } from '@lingui/macro';
import { IconChevronRight } from '@tabler/icons-react';
import { Box, Flex, Text } from '~/design-system';
import ImportTypeSelector from '../../pages/imports/add/ImportTypeSelector';
import { getActiveDescriptors, getDescriptors } from '../../descriptors';

type BrowseAllPanelProps = {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
};

export default function BrowseAllPanel({
  open: openProp,
  onOpenChange,
}: BrowseAllPanelProps = {}) {
  const [internalOpen, setInternalOpen] = useState(false);
  const open = openProp ?? internalOpen;
  const setOpen = (next: boolean) => {
    if (onOpenChange) onOpenChange(next);
    else setInternalOpen(next);
  };
  const [includeLegacy, setIncludeLegacy] = useState(false);
  const activeCount = getActiveDescriptors().length;
  const legacyCount = getDescriptors().length - activeCount;

  const panelId = 'browse-all-import-types-panel';
  return (
    <Box>
      <Box
        as="button"
        // @ts-ignore — Box typing doesn't surface button-element props
        type="button"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        aria-controls={panelId}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          padding: 0,
          background: 'transparent',
          border: 'none',
          color: '#374151',
          fontSize: '14px',
          cursor: 'pointer',
          '&:hover': { color: '#111827' },
        }}
      >
        <Box
          sx={{
            display: 'inline-flex',
            transition: 'transform 120ms ease',
            transform: open ? 'rotate(90deg)' : 'rotate(0deg)',
          }}
        >
          <IconChevronRight size={16} stroke={2} />
        </Box>
        <Trans>Or browse all {activeCount} import types</Trans>
      </Box>
      {open && (
        <Box id={panelId} sx={{ marginTop: 3 }}>
          <ImportTypeSelector includeLegacy={includeLegacy} />
          {legacyCount > 0 && (
            <Flex
              sx={{
                alignItems: 'center',
                gap: 2,
                marginTop: 2,
                paddingX: 1,
              }}
            >
              {/* @ts-ignore — Box typing doesn't surface input-element props */}
              <Box
                as="input"
                type="checkbox"
                id="show-legacy-importers"
                checked={includeLegacy}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setIncludeLegacy(e.target.checked)
                }
                sx={{ margin: 0 }}
              />
              {/* @ts-ignore — Text doesn't type label htmlFor */}
              <Text
                as="label"
                htmlFor="show-legacy-importers"
                sx={{ fontSize: '13px', color: '#6b7280', cursor: 'pointer' }}
              >
                <Trans>
                  Show {legacyCount} legacy importers (superseded but still
                  available)
                </Trans>
              </Text>
            </Flex>
          )}
        </Box>
      )}
    </Box>
  );
}
